import React from "react";
import "../css/dashboard.css";
import Navbar from "../component/Navbar";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import CheatsheetContent from "./CheatsheetContent";
import CheatsheetContentMobile from "./CheatsheetContentMobile";

export default function Cheatsheet() {
  const navigate = useNavigate();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });

  return (
    <div className="main-container-cheatsheet">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          {/* <NoMobileView title="Room booking" /> */}
          <CheatsheetContentMobile />
        </>
      ) : (
        <>
          <Navbar linkActive={12} />
          <CheatsheetContent />
        </>
      )}
    </div>
  );
}
